import root from 'window-or-global';
import React, {
  createContext, useState, useContext, useMemo,
} from 'react';
import { oneOfType, arrayOf, node } from 'prop-types';

export const DataLoadContext = createContext();

export const useDataLoadContext = () => useContext(DataLoadContext) || {};

export const DataLoadProvider = ({ children }) => {
  const { google = {} } = root;
  const { maps } = google;

  const [scriptsLoaded, setScriptsLoaded] = useState(false);
  const [recaptchaLoaded, setRecaptchaLoaded] = useState(!root.recaptcha);
  const [userLoaded, setUserLoaded] = useState(false);
  const [mapsLoaded, setMapsLoaded] = useState(!maps);
  const [stripeLoaded, setStripeLoaded] = useState(!root.Stripe);

  const memo = useMemo(() => ({
    scriptsLoading: !scriptsLoaded,
    userLoading: !userLoaded,
    recaptchaLoading: !recaptchaLoaded,
    mapsLoading: !mapsLoaded,
    stripeLoading: !stripeLoaded,
  }), [scriptsLoaded, userLoaded,
    recaptchaLoaded, mapsLoaded,
    stripeLoaded]);

  return (
      <DataLoadContext.Provider
        value={{
          ...memo,
          recaptchaScriptLoaded: async () => {
            setRecaptchaLoaded(false);
            if (!root.recaptcha) {
              const { forceWait } = await import('apputil/retry-promise');
              await forceWait({ time: 500 });
            }
            setRecaptchaLoaded(true);
            return true;
          },
          pageScriptsLoaded: async () => {
            // this function is called in Layout
            setScriptsLoaded(false);
            if (!root.dataLayer) {
              const { forceWait } = await import('apputil/retry-promise');
              await forceWait({ time: 500 });
            }
            setScriptsLoaded(true);
            return true;
          },
          userDataLoadingCallback: () => {
            setUserLoaded(false);
            return (action) => {
              if (action) {
                action();
              }
              setUserLoaded(true);
            };
          },
          mapsScriptsLoaded: async () => {
            setMapsLoaded(false);
            if (!maps) {
              const { forceWait } = await import('apputil/retry-promise');
              await forceWait({ time: 500 });
            }
            setMapsLoaded(true);
            return true;
          },
          stripeScriptsLoaded: async () => {
            setStripeLoaded(false);
            const { forceWait } = await import('apputil/retry-promise');
            if (!root.Stripe) {
              await forceWait({ time: 1000 });
            }
            if (!root.Stripe) {
              await forceWait({ time: 1000 });
            }
            if (!root.Stripe) {
              await forceWait({ time: 1000 });
            }
            if (!root.Stripe) {
              await forceWait({ time: 1000 });
            }
            setStripeLoaded(true);
            return true;
          },
        }}>
        {children}
      </DataLoadContext.Provider>
  );
};

DataLoadProvider.propTypes = {
  children: oneOfType([arrayOf(node), node]).isRequired,
};
